import { TRUCK_IMAGE, COMPANY } from "../lib/constants";
import { Phone, Truck } from "lucide-react";

export default function TruckCard({ cityName }) {
  return (
    <section
      data-testid="truck-card"
      className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20"
    >
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-slate-900 via-slate-900 to-teal-900 p-8 md:p-12">
        <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-teal-500/20 blur-3xl" />
        <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-[radial-gradient(ellipse_at_bottom,_rgba(44,168,182,0.18),transparent_70%)]" />

        <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1 text-white space-y-4">
            <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-teal-300">
              <Truck className="w-3.5 h-3.5" />
              Atelier mobile
            </div>
            <h2 className="font-display text-2xl md:text-4xl font-extrabold tracking-tight leading-tight">
              Notre véhicule arrive
              {cityName ? (
                <>
                  {" "}à <span className="text-teal-300">{cityName}</span>
                </>
              ) : (
                <> <span className="text-teal-300">chez vous</span></>
              )}.
            </h2>
            <p className="text-slate-300 leading-relaxed max-w-xl">
              Équipé en permanence de nos cylindres, serrures, blindages et
              outillage professionnel — nous traitons la majorité des
              interventions <strong className="text-white">dès le premier déplacement</strong>.
            </p>
          </div>
          <div className="lg:col-span-6 order-1 lg:order-2 relative">
            <img
              src={TRUCK_IMAGE}
              alt={`Véhicule Mon Serrurier Breton intervenant${cityName ? ` à ${cityName}` : ""}`}
              data-testid="truck-card-image"
              className="relative z-10 w-full h-auto object-contain drop-shadow-[0_30px_50px_rgba(0,0,0,0.45)]"
            />
            <div className="absolute bottom-2 left-4 right-4 h-6 bg-black/50 blur-2xl rounded-full" />
          </div>
        </div>

        <div className="relative mt-8 flex flex-col md:flex-row items-start md:items-center gap-4 justify-between">
          <div className="text-slate-300 text-sm">
            Disponible 24h/24, 7j/7 — y compris week-ends et jours fériés.
          </div>
          <a
            href={`tel:${COMPANY.phoneDigits}`}
            data-testid="truck-card-call"
            className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-full px-6 py-3 shadow-xl"
          >
            <Phone className="w-4 h-4" /> {COMPANY.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
